import React, { useState } from "react";
import ObjectSelectedDetails from "../SelectedDetails/ObjectSelectedDetails";
import ObjectSelectedStatus from "../SelectedStatus/ObjectSelectedStatus";
import ObjectSelectedSensors from "../SelectedSensors/ObjectSelectedSensors";
import ObjectSelectedControls from "../SelectedControls/ObjectSelectedControls";
import ObjectSelectedCamera from "../SelectedCamera/ObjectSelectedCamera";
import trans from "../../../../utils";
import { useSelector } from "react-redux";

export default function ObjectSelectedTabs({
	title,
	img,
	values,
	device,
	position,
	CarSensors,
	show
}) {
	const [openDropdown, setOpenDropdown] = useState(null);
	const inf = useSelector((state) => state.users.user)
	const toggleDropdown = (name) => {
		setOpenDropdown(openDropdown === name ? null : name);
	};
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div className="object-body-title" onClick={() => toggleDropdown(title)}>
				<div className="flex-between">
					<div className={`${lang === "en" ? "mr-16" : "ml-16"}`}>
						<img src={`${process.env.PUBLIC_URL}/assets/${img}.svg`} alt="" />
					</div>
					<div className="fs-16 fw-600" role="button">
						{trans(title)}
					</div>
				</div>
				{title !== "vehicle details" && (
					<div>
						<img
							role="button"
							src={
								openDropdown === title
									? `${process.env.PUBLIC_URL}/assets/Uparrow.svg`
									: `${process.env.PUBLIC_URL}/assets/Downarrow.svg`
							}
							alt="arrow"
							className={show === false && "d-none"}
						/>
					</div>
				)}
			</div>


			{title === "Vehicle Details" ? (
				<div>
					<ObjectSelectedDetails device={device} details={values} />
				</div>
			) : (
				openDropdown === title && (
					<div>
						{title === "working status" && (
							<ObjectSelectedStatus
								details={values}
								device={device}
								position={position}
							/>
						)}
						{title === "sensors" && (
							<ObjectSelectedSensors
								position={position}
								CarSensors={CarSensors}
							/>
						)}
						{ title === "controls" && <ObjectSelectedControls device={device} />}
						{title === "camera" && <ObjectSelectedCamera />}
					</div>
				)
			)}
		</>
	);
}
